module.exports = __webpack_public_path__ + "img/social-icon-email.1da1e646.png";